<!-- 设置价格&产量 -->
<template>
  <div>
    <el-dialog
      width="1400px"
      :title="`设置${type}`"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="popup-main">
        <!-- 选项卡-模板 -->
        <TabsMuBan :key="activeIndexMuBan" :index.sync="activeIndexMuBan" :list="selfList" />
        <!-- 选项卡-价格 -->
        <TabsPrice
          :key="activeIndexPrice"
          :index.sync="activeIndexPrice"
          :type="type"
          class="flex-1"
        >
          <!-- 设置产量 -->
          <div v-if="activeIndexPrice === '设置产量'">
            <e-form :column="chanLiangFormColumn" :data.sync="verifyData" />
            <TabsType
              :key="`chanliang-${activeIndexChanLiangType}`"
              :index.sync="activeIndexChanLiangType"
            >
              <vxe-grid
                :height="512"
                :min-height="tableConfig.minHeight"
                :toolbar-config="tableConfig.toolbarConfig"
                :row-config="tableConfig.rowConfig"
                :keyboard-config="tableConfig.keyboardConfig"
                :columns="chanLiangTableColumn"
                :data="selfData.ji_chu_chan_liang_list[Number(activeIndexChanLiangType)]"
              >
                <!-- slot_header -->
                <template #header_tiao_zheng_scope>
                  {{
                    activeIndexChanLiangType === '0'
                      ? '参数范围'
                      : `参数匹配(用英文星号'*'或逗号','分隔)`
                  }}
                </template>
                <!-- slot_default -->
                <template #default_tiao_zheng_key_list="{ row }">
                  <e-select-array
                    :multiple="!!Number(activeIndexChanLiangType)"
                    :allList="chanLiangCanShuList"
                    :activeList.sync="row.tiao_zheng_key_list"
                  />
                </template>
                <template #default_tiao_zheng_scope="{ row }">
                  <div v-if="activeIndexChanLiangType === '0'" class="flex flex-y-center">
                    <el-input v-model="row.tiao_zheng_scope_start" size="mini" clearable>
                      <span slot="suffix">最小值</span>
                    </el-input>
                    <span class="m-x-5">-</span>
                    <el-input v-model="row.tiao_zheng_scope_end" size="mini" clearable>
                      <span slot="suffix">最大值</span>
                    </el-input>
                  </div>
                  <div v-else class="flex flex-y-center">
                    <el-input v-model="row.tiao_zheng_scope_val" size="mini" clearable>
                      <span slot="suffix">{{ row.tiao_zheng_key_list.join(',') }}</span>
                    </el-input>
                  </div>
                </template>
                <template #default_tiao_zheng_type="{ row }">
                  <el-select size="mini" v-model="row.tiao_zheng_type" clearable>
                    <el-option
                      v-for="(item, index) in tiaoZhengTypeList"
                      :key="index"
                      :label="item.key"
                      :value="item.val"
                    />
                  </el-select>
                </template>
                <template #default_tiao_zheng_val="{ row }">
                  <el-input type="number" size="mini" v-model="row.tiao_zheng_val" clearable>
                    <span v-if="row.tiao_zheng_type" slot="suffix">
                      {{ row.tiao_zheng_type === '0' || row.tiao_zheng_type === '1' ? '件' : '%' }}
                    </span>
                  </el-input>
                </template>
                <template #default_do="{ rowIndex }">
                  <el-link type="success" @click="rowAddChanLiang">增行</el-link>
                  <el-link
                    v-if="
                      selfData.ji_chu_chan_liang_list[Number(activeIndexChanLiangType)].length > 1
                    "
                    type="danger"
                    @click="rowDeleteChanLiang(rowIndex)"
                  >
                    删行
                  </el-link>
                </template>
                <!-- 数据为空 -->
                <template #empty>
                  <div class="flex flex-center">
                    <span class="f-s-14 c-gray-light">暂无数据</span>
                    <el-link class="m-l-10" type="success" @click="rowAddChanLiang">增行</el-link>
                  </div>
                </template>
              </vxe-grid>
            </TabsType>
          </div>

          <!-- 校验产量 -->
          <div v-if="activeIndexPrice === '校验产量'">
            <div class="table-bottom">
              <div class="verify-cont">
                <div class="verify-title">校验示例:</div>
                <div class="m-t-10">
                  <e-form ref="refVerifyForm" :column="verifyFormColumn" :data.sync="verifyData" />
                </div>
                <el-button type="warning" size="mini" @click="actionVerify">开始校验</el-button>
              </div>
            </div>
            <div style="height: 549px"></div>
          </div>

          <!-- 设置价格 -->
          <div v-if="activeIndexPrice === '设置价格'">
            <e-form :column="jiaGeFormColumn" :data.sync="verifyData" />
            <TabsType :key="`jiage-${activeIndexJiaGeType}`" :index.sync="activeIndexJiaGeType">
              <vxe-grid
                :height="512"
                :toolbar-config="tableConfig.toolbarConfig"
                :row-config="tableConfig.rowConfig"
                :keyboard-config="tableConfig.keyboardConfig"
                :columns="jiaGeTableColumn"
                :data="selfData.ji_chu_jia_ge_list[Number(activeIndexJiaGeType)]"
              >
                <!-- slot_header -->
                <template #header_tiao_zheng_scope>
                  {{
                    activeIndexJiaGeType === '0'
                      ? '参数范围'
                      : `参数匹配(用英文星号'*'或逗号','分隔)`
                  }}
                </template>
                <!-- slot_default -->
                <template #default_tiao_zheng_key_list="{ row }">
                  <e-select-array
                    :multiple="!!Number(activeIndexJiaGeType)"
                    :allList="jiaGeCanShuList"
                    :activeList.sync="row.tiao_zheng_key_list"
                  />
                </template>
                <template #default_tiao_zheng_scope="{ row }">
                  <div v-if="activeIndexJiaGeType === '0'" class="flex flex-y-center">
                    <el-input v-model="row.tiao_zheng_scope_start" size="mini" clearable>
                      <span slot="suffix">最小值</span>
                    </el-input>
                    <span class="m-x-5">-</span>
                    <el-input v-model="row.tiao_zheng_scope_end" size="mini" clearable>
                      <span slot="suffix">最大值</span>
                    </el-input>
                  </div>
                  <div v-else class="flex flex-y-center">
                    <el-input v-model="row.tiao_zheng_scope_val" size="mini" clearable>
                      <span slot="suffix">{{ row.tiao_zheng_key_list.join(',') }}</span>
                    </el-input>
                  </div>
                </template>
                <template #default_tiao_zheng_type="{ row }">
                  <el-select size="mini" v-model="row.tiao_zheng_type" clearable>
                    <el-option
                      v-for="(item, index) in tiaoZhengTypeList"
                      :key="index"
                      :label="item.key"
                      :value="item.val"
                    />
                  </el-select>
                </template>
                <template #default_tiao_zheng_val="{ row }">
                  <el-input type="number" size="mini" v-model="row.tiao_zheng_val" clearable>
                    <span v-if="row.tiao_zheng_type" slot="suffix">
                      {{ row.tiao_zheng_type === '0' || row.tiao_zheng_type === '1' ? '元' : '%' }}
                    </span>
                  </el-input>
                </template>
                <template #default_do="{ rowIndex }">
                  <el-link type="success" @click="rowAddJiage">增行</el-link>
                  <el-link
                    v-if="selfData.ji_chu_jia_ge_list[Number(activeIndexJiaGeType)].length > 1"
                    type="danger"
                    @click="rowDeleteJiage(rowIndex)"
                  >
                    删行
                  </el-link>
                </template>
                <!-- 数据为空 -->
                <template #empty>
                  <div class="flex flex-center">
                    <span class="f-s-14 c-gray-light">暂无数据</span>
                    <el-link class="m-l-10" type="success" @click="rowAddJiage">增行</el-link>
                  </div>
                </template>
              </vxe-grid>
            </TabsType>
          </div>

          <!-- 校验价格 -->
          <div v-if="activeIndexPrice === '校验价格'">
            <div class="table-bottom">
              <div class="verify-cont">
                <div class="verify-title">校验示例:</div>
                <div class="m-t-10">
                  <e-form ref="refVerifyForm" :column="verifyFormColumn" :data.sync="verifyData" />
                </div>
                <el-button type="warning" size="mini" @click="actionVerify">开始校验</el-button>
              </div>
            </div>
            <div class="verify-table">
              <vxe-grid
                :height="539"
                :toolbar-config="tableConfig.toolbarConfig"
                :row-config="tableConfig.rowConfig"
                :keyboard-config="tableConfig.keyboardConfig"
                :merge-cells="verifyMergeCell"
                :columns="verifyTableColumn"
                :data="effectDanWeiList"
              >
                <!-- slot_default -->
                <template #default_dan_wei_name="{ row }">
                  <div class="flex flex-y-center flex-x-between">
                    <span>{{ row.dan_wei_name }}</span>
                    <span v-if="row.is_mo_ren_dan_wei" class="unit-sub-tag">默认单位</span>
                  </div>
                </template>
                <template #default_verify_unit_val="{ row }">
                  <div class="flex flex-y-center flex-x-between">
                    <span class="flex-1 m-r-5">
                      {{ $util.getNumberFullString(row.verify_unit_val) }}
                    </span>
                    <span class="c-gray-light">{{ row.dan_wei_name }}</span>
                  </div>
                </template>
                <template #default_verify_price_val="{ row }">
                  <div class="flex flex-y-center flex-x-between">
                    <span class="flex-1 m-r-5">
                      {{ $util.getNumberFullString(row.verify_price_val) }}
                    </span>
                    <span class="c-gray-light">{{ `元/${row.dan_wei_name}` }}</span>
                  </div>
                </template>
              </vxe-grid>
            </div>
          </div>
        </TabsPrice>
      </div>
      <div slot="footer">
        <el-button size="mini" @click="popupCancel">取消</el-button>
        <el-button size="mini" type="primary" @click="popupConfirm">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import TabsMuBan from './tabs-mu-ban'
import TabsPrice from './tabs-price'
import TabsType from './tabs-type'

export default {
  components: {
    TabsMuBan,
    TabsPrice,
    TabsType
  },
  props: {
    show: {
      type: Boolean,
      required: true
    },
    list: {
      type: Array,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    isFromSheBei: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selfShow: false,
      selfList: [],
      selfData: this.$util.deepCopy(this.$constant.muBanShangPinDefaultData),
      activeIndexMuBan: '0',
      activeIndexPrice: `设置${this.type}`,

      // 产量设置-相关字段
      activeIndexChanLiangType: '0',
      chanLiangFormColumn: [
        {
          type: 'text',
          field: 'mo_ren_dan_wei_zu',
          title: '默认单位',
          required: true,
          disabled: true
        },
        {
          type: 'text',
          field: 'ji_chu_chan_liang',
          title: '基础产量',
          suffix: '件',
          required: true
        }
      ],
      chanLiangTableColumn: [
        {
          title: '参数名称',
          field: 'tiao_zheng_key_list',
          width: 360,
          slots: { default: 'default_tiao_zheng_key_list' },
          editRender: { autofocus: '.el-input__inner' }
        },
        {
          width: 300,
          slots: { header: 'header_tiao_zheng_scope', default: 'default_tiao_zheng_scope' }
        },
        {
          title: '调整方式',
          field: 'tiao_zheng_type',
          slots: { default: 'default_tiao_zheng_type' }
        },
        {
          title: '调整产量',
          field: 'tiao_zheng_val',
          slots: { default: 'default_tiao_zheng_val' }
        },
        {
          title: '操作',
          slots: { default: 'default_do' }
        }
      ],

      // 价格设置-相关字段
      activeIndexJiaGeType: '0',
      jiaGeFormColumn: [
        {
          type: 'text',
          field: 'mo_ren_dan_wei_zu',
          title: '默认单位',
          required: true,
          disabled: true
        },
        {
          type: 'text',
          field: 'ji_chu_jia_ge',
          title: '基价',
          suffix: '元',
          required: true
        }
      ],
      jiaGeTableColumn: [
        {
          title: '参数名称',
          field: 'tiao_zheng_key_list',
          width: 360,
          slots: { default: 'default_tiao_zheng_key_list' },
          editRender: { autofocus: '.el-input__inner' }
        },
        {
          width: 240,
          slots: { header: 'header_tiao_zheng_scope', default: 'default_tiao_zheng_scope' }
        },
        {
          title: '调整方式',
          field: 'tiao_zheng_type',
          slots: { default: 'default_tiao_zheng_type' }
        },
        {
          title: '调整价格',
          field: 'tiao_zheng_val',
          slots: { default: 'default_tiao_zheng_val' }
        },
        {
          title: '操作',
          slots: { default: 'default_do' }
        }
      ],

      // 价格校验-相关字段
      verifyFormColumn: [],
      verifyData: {
        mo_ren_dan_wei_zu: '',
        gui_ge_shi_li: '',
        ji_chu_jia_ge: '',
        ji_chu_chan_liang: '',
        ji_jia_shi_li: '',
        chan_liang_shi_li: ''
      },
      verifyTableColumn: [
        {
          title: '单位分组',
          field: 'dan_wei_zu_name',
          isMerge: true
        },
        {
          title: '单位',
          field: 'dan_wei_name',
          slots: { default: 'default_dan_wei_name' }
        },
        {
          title: '单位参数校验',
          field: 'verify_unit_val',
          slots: { default: 'default_verify_unit_val' }
        },
        {
          title: '单价参数校验',
          field: 'verify_price_val',
          slots: { default: 'default_verify_price_val' }
        }
      ],
      verifyMergeCell: [],

      // 其他
      tiaoZhengTypeList: [
        {
          key: '上调数值',
          val: '0'
        },
        {
          key: '下调数值',
          val: '1'
        },
        {
          key: '上调比例',
          val: '2'
        },
        {
          key: '下调比例',
          val: '3'
        }
      ],
      danWeiZuList: []
    }
  },
  computed: {
    // 表格配置合并
    tableConfig() {
      let obj = {}
      let result = this.$util.deepMerge(this.$constant.tableDefaultConfig, obj)
      return result
    },
    // 单位是否使用产量
    isUnitUseChanLiang() {
      let isUnitShiJian = this.selfData.mo_ren_dan_wei_zu.includes('时间')
      let result = this.isFromSheBei && isUnitShiJian
      return result
    },
    // 产量参数列表
    chanLiangCanShuList() {
      let result = this.selfData.gui_ge_list.map((item) => {
        let obj = {
          key: item,
          val: item
        }
        return obj
      })
      return result
    },
    // 价格规格列表
    jiaGeCanShuList() {
      let result = []
      if (this.isUnitUseChanLiang) {
        result = [{ key: '产量', val: '产量' }]
      } else {
        result = this.selfData.gui_ge_list.map((item) => {
          let obj = {
            key: item,
            val: item
          }
          return obj
        })
      }
      return result
    },
    // 有效的单位列表
    effectDanWeiList() {
      let result = []
      let isTimeMoRenDanWei = this.danWeiZuList.some((item) => {
        return item.dan_wei_zu_name === '时间' && item.is_mo_ren_dan_wei
      })
      this.danWeiZuList.forEach((item) => {
        if (item.dan_wei_zu_name === '时间') {
          if (isTimeMoRenDanWei) result.push(item)
        } else {
          result.push(item)
        }
      })
      return result
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    },
    activeIndexMuBan() {
      this.checkSelfData()
    },
    'selfData.dan_wei_zu_list': {
      handler(val) {
        this.danWeiZuList = []
        val.forEach((itemSt) => {
          itemSt.dan_wei_list.forEach((itemNd) => {
            let obj = this.$util.deepCopy(itemNd)
            let result = {
              dan_wei_zu_name: itemSt.dan_wei_zu_name,
              dan_wei_zu_id: itemSt.id,
              ...obj
            }
            this.danWeiZuList.push(result)
          })
        })

        this.verifyMergeCell = this.$tool.getMergeCellConfigList(
          this.effectDanWeiList,
          this.verifyTableColumn,
          'dan_wei_zu_name'
        )
      },
      deep: true,
      immediate: true
    },
    verifyData: {
      handler(val) {
        this.selfData.gui_ge_shi_li = val.gui_ge_shi_li
        this.selfData.ji_chu_jia_ge = val.ji_chu_jia_ge
        this.selfData.ji_chu_chan_liang = val.ji_chu_chan_liang
        this.selfData.fu_jia_can_shu_shi_li = this.selfData.fu_jia_can_shu_list.map(
          (item, index) => {
            let fieldName = `fu_jia_can_shu_${index}`
            let result = val[fieldName]
            return result
          }
        )
      },
      deep: true
    }
  },
  mounted() {
    this.selfShow = this.show
    let selfList = this.$util.deepCopy(this.list)
    selfList.forEach((itemSt) => {
      itemSt.dan_wei_zu_list.forEach((itemNd) => {
        itemNd.dan_wei_list.forEach((itemRd) => {
          itemRd.verify_unit_val = ''
          itemRd.verify_price_val = ''
        })
      })
    })
    this.selfList = selfList
    this.checkSelfData()
  },
  methods: {
    checkSelfData() {
      this.selfData = this.selfList[Number(this.activeIndexMuBan)]

      let verifyData = {
        mo_ren_dan_wei_zu: this.$tool.getDanWei(this.selfData.mo_ren_dan_wei_zu),
        gui_ge_shi_li: this.selfData.gui_ge_shi_li,
        ji_chu_jia_ge: this.selfData.ji_chu_jia_ge,
        ji_chu_chan_liang: this.selfData.ji_chu_chan_liang,
        ji_jia_shi_li: '',
        chan_liang_shi_li: ''
      }
      let verifyFormColumn = []

      this.selfData.fu_jia_can_shu_list.forEach((item, index) => {
        let fieldName = `fu_jia_can_shu_${index}`
        verifyData[fieldName] = this.selfData.fu_jia_can_shu_shi_li[index] || ''
        let obj = {
          type: 'text',
          field: fieldName,
          title: item.name,
          width: '189px'
        }
        verifyFormColumn.push(obj)
      })

      this.verifyData = verifyData
      this.initVerifyFormComumn(verifyFormColumn)
    },
    // 初始化校验参数
    initVerifyFormComumn(verifyFormColumn) {
      this.verifyFormColumn = [
        {
          type: 'text',
          field: 'gui_ge_shi_li',
          title: '规格示例',
          placeholder: this.selfData.gui_ge_list.join('*'),
          width: '189px',
          required: true
        },
        ...verifyFormColumn,
        {
          type: 'text',
          field: 'ji_jia_shi_li',
          title: '基价示例',
          placeholder: '自动计算',
          width: '189px',
          required: true,
          disabled: true,
          hide: this.type === '产量'
        },
        {
          type: 'text',
          field: 'chan_liang_shi_li',
          title: '产量示例',
          placeholder: '自动计算',
          width: '189px',
          required: true,
          disabled: true,
          hide: !this.selfData.mo_ren_dan_wei_zu.includes('时间')
        }
      ]
    },
    // 增行-价格
    rowAddJiage() {
      let result = {
        tiao_zheng_key_list: [], // 参数列表
        tiao_zheng_scope_start: '', // 参数范围-开始
        tiao_zheng_scope_end: '', // 参数范围-结束
        tiao_zheng_scope_val: '', // 参数范围-匹配值
        tiao_zheng_type: '', // 调整方式
        tiao_zheng_val: '' // 调整值
      }
      this.selfData.ji_chu_jia_ge_list[Number(this.activeIndexJiaGeType)].push(result)
    },
    // 删行-价格
    rowDeleteJiage(index) {
      this.selfData.ji_chu_jia_ge_list[Number(this.activeIndexJiaGeType)].splice(index, 1)
    },
    // 增行-产量
    rowAddChanLiang() {
      let result = {
        tiao_zheng_key_list: [], // 参数列表
        tiao_zheng_scope_start: '', // 参数范围-开始
        tiao_zheng_scope_end: '', // 参数范围-结束
        tiao_zheng_scope_val: '', // 参数范围-匹配值
        tiao_zheng_type: '', // 调整方式
        tiao_zheng_val: '' // 调整值
      }
      this.selfData.ji_chu_chan_liang_list[Number(this.activeIndexChanLiangType)].push(result)
    },
    // 删行-产量
    rowDeleteChanLiang(index) {
      this.selfData.ji_chu_chan_liang_list[Number(this.activeIndexChanLiangType)].splice(index, 1)
    },
    // 开始校验
    actionVerify() {
      this.$tool.actionVerify(this.verifyData, this.selfData)
    },
    // 弹窗取消
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    },
    // 弹窗确认
    popupConfirm() {
      this.$emit('success', this.selfList)
      this.popupCancel()
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
  display: flex;
  /deep/ .el-input__suffix {
    line-height: 28px;
  }

  .table-bottom {
    display: flex;
    align-items: center;
    padding: 5px;
    border: @borderTable;
    .verify-cont {
      display: flex;
      align-items: center;
      height: 28px;
      overflow: hidden;
      .verify-title {
        padding: 0 10px;
        margin-right: 10px;
        text-align: center;
        line-height: 28px;
        font-size: 12px;
        color: @colorOrangeYellow;
        background: @colorOrangeYellow20;
        border-radius: 3px;
      }
      /deep/ .el-button {
        height: 28px;
        line-height: 28px;
        padding: 0 10px;
      }
    }
  }

  .verify-table {
    margin-top: 10px;
    /deep/ .vxe-table--render-default.size--mini .vxe-body--column:not(.col--ellipsis) {
      height: 18px;
    }
  }

  .unit-sub-tag {
    color: @colorWhite;
    padding: 0 2px;
    margin-right: 5px;
    border-radius: 2px;
    background: @colorGreen;
  }
}
</style>
